// extracted by mini-css-extract-plugin
export default {"sliderContainer":"ClickSlider_sliderContainer__k8sFR","slide":"ClickSlider_slide__MaUm8","image":"ClickSlider_image__zqrFK","text":"ClickSlider_text__9kbeg"};